import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_DOCUMENTS_LABELS_BY_COMPANY = gql`
  query getDocumentLabelsByCompany($companyId: String!, $queryOptions: QueryOptionsInput) {
    getDocumentLabelsByCompany(companyId: $companyId, queryOptions: $queryOptions) {
      collection {
        _id
        name
        availableForEmployee
        documentTemplates {
          _id
          title
          fileId
          createdBy
          file {
            _id
            key
            filename
            location
          }
        }
      }
      totalCount
    }
  }
`;

export const useGetDocumentLabelsByCompany = (companyId?: string) => {
  const { data, loading } = useQuery(GET_DOCUMENTS_LABELS_BY_COMPANY, {
    variables: { companyId },
    skip: !companyId,
    fetchPolicy: 'network-only',
  });

  const { collection = [] } = data?.getDocumentLabelsByCompany || {};

  return { documentsLabels: collection, loading };
};

export const useGetDocumentLabelsListByCompany = (companyId?: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>();
  const pageSize = 12;
  const { data, loading } = useQuery(GET_DOCUMENTS_LABELS_BY_COMPANY, {
    variables: {
      companyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    skip: !companyId,
    fetchPolicy: 'cache-and-network',
  });

  const { totalCount = 0, collection = [] } = data?.getDocumentLabelsByCompany || {};

  return {
    loading,
    documentsLabels: collection,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'name', sortBy }]);
      }
    },
  };
};
